export default __webpack_public_path__ + "static/media/loha-app.eabc88d3.jpg";